import React from 'react';
import { useParams } from 'react-router-dom';

export function AutomedScripts() {
    const { automedSiteId, automedPath, locationId } = useParams();

    const scriptsUrl = `${import.meta.env.VITE_AUTOMED_URL}/myhealth/clinics/${automedSiteId}/${automedPath}/scripts/loc/${locationId}`;

    return <iframe className="h-screen w-screen" src={scriptsUrl} />;
}
